module.exports = __webpack_public_path__ + "static/img/meditation-home-hover.f542b74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doom-yoga/meditation-home-hover.png
// module id = R8oe
// module chunks = 0